import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import queryString from "app/services/queryStringService";
import _ from "lodash";

import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import EditBank from "./EditBank";
import { NotificationManager } from "react-notifications";
import {
  getBankList,
  bankUpdate,
  deleteBanks,
} from "app/services/AdminServices/bankService";
import { MdDelete } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import { Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";

const BankLists = () => {
  const { canAdd, canEdit, canDelete } = usePagePermission();
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isShow, setIsShow] = useState(false);
  const [editModelValues, setEditModelValues] = useState({});

  const actionFormatter = (cell) => {
    if (cell === true) {
      return <span style={{ color: "green" }}> Active</span>;
    } else {
      return <span style={{ color: "red" }}> Inactive</span>;
    }
  };

  const editBankDetails = (row) => {
    setEditModelValues(row);
  };

  const onDelete = async (row) => {
    Swal.fire({
      title: `Are you sure you want to Delete this Details?`,
      icon: "warning",

      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const response = await deleteBanks(row.id);
        if (response.status === "Success") {
          NotificationManager.success("Delete Successfully", "success", 5000);
          loadBankLists();
        } else {
          NotificationManager.error(response.message, "Error", 5000);
          //   // loadBankLists();
        }
      } else {
        Swal.fire({
          title: "Cancelled!",
          text: "Permission denied.",

          icon: "error",
          timer: 1500,
        });
      }
    });
  };

  const editFormatter = (cell, row) => {
    return (
      <>
        <Row>
          <Col xs={12} lg={12}>
            <AiFillEdit
              data-bs-toggle="modal"
              data-bs-target="#editBankModal"
              onClick={() => editBankDetails(row)}
              size="1.5em"
              color="black"
              cursor={"pointer"}
            ></AiFillEdit>
          </Col>

          {/* <Col xs={3} lg={3}>
            {row.status == false ? (
              <MdDelete
                cursor={"pointer"}
                onClick={() => onDelete(row)}
                size="1.5em"
                color="red"
                variant="danger"
                className="mx-4"
              />
            ) : (
              <MdDelete
                style={{ color: "gray", cursor: "not-allowed" }}
                size="1.5em"
                className="mx-4"
              />
            )}
          </Col> */}
        </Row>
      </>
    );
  };

  const columns = [
    {
      dataField: "accountHolderName",
      text: "Account Holder Name",
      headerStyle: () => {
        return { width: "180px", textAlign: "center" };
      },
    },
    {
      dataField: "bankName",
      text: "Bank Name",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "shortCode",
      text: "Bank Short Code",
      headerStyle: () => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },

      //  formatter: this.companyFormatter,
    },

    {
      dataField: "address",
      text: "Address",
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "accountNumber",
      text: "Account Number",
      headerStyle: () => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "ifscCode",
      text: "IFSC Code",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "swiftCode",
      text: "Swift Code",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: editFormatter,
    },
    // Rest of the columns...
  ];

  const rowStyle = () => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadBankLists = async () => {
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getBankList();
    const data = response.data;

    setData(data);
    setDataCount(data.length);
    setLoading(false);
  };

  useEffect(() => {
    loadBankLists();
  }, []);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    // return false; // No need for this
    setTimeout(async () => {
      await loadBankLists();
    }, 10);
  };

  const handleEditSubmit = async (data) => {
    debugger;
    setIsShow(true);
    const res = await bankUpdate(data.id, data);

    try {
      if (res) {
        NotificationManager.success("Updated Successfully.");
        document.getElementsByClassName("btn-close")[0].click();
        await loadBankLists();
        setIsShow(false);
      }
    } catch (error) {
      NotificationManager.error(error);
      console.log(error);
      setIsShow(false);
    }
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      {canAdd && (
        <Link className="btn btn-primary btn-md float-end" to="/admin/bank/add">
          <i className="i-Add-User text-white mr-2"></i> Add Bank
        </Link>
      )}
      <Helmet>
        <title>Bank List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Bank List" }]}></Breadcrumb>

      <div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              //  remote
              keyField="id"
              data={data}
              columns={
                canEdit ? columns : columns.filter((x) => x.text !== "Action")
              }
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
      {editModelValues ? (
        <EditBank
          editModelValues={editModelValues}
          handleEditSubmit={handleEditSubmit}
          isShow={isShow}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default BankLists;
